import Vue from 'vue';
import AbrechnungService from './abrechnung.service';

const getDefaultItem = () => ({
    mandantId: null,
    anzahlBeleg: null,
    letztesBelegsDatum: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const abrechnung = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await AbrechnungService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await AbrechnungService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await AbrechnungService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await AbrechnungService.query(params);
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await AbrechnungService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default abrechnung;
